
import { RESET } from '@/store/mutations';
import { defineComponent } from 'vue';
import TheCalculatorInputsPanel from './input-panel/TheCalculatorInputsPanel.vue';
import TheCalculatorResultPanel from './result-panel/TheCalculatorResultPanel.vue';

export default defineComponent({
  name: 'calculator',
  components: { TheCalculatorResultPanel, TheCalculatorInputsPanel },
  methods: {
    handleReset() {
      this.$store.commit(RESET);
    },
  },
});
